import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import {
  listFiles,
  listFilesNext,
  listShareBuckets,
  listSharedFiles,
  listSharedFilesNext,
  listPropertyFolderFiles,
  listPropertyFolderFilesNext,
  listTrashFiles,
  listTrashFilesNext,
  restoreTrashFile,
} from './thunks/files';
import {
  createFolder,
  deleteFile,
  deleteQuoteSet,
  downloadFile,
  downloadFileData,
  duplicateFile,
  getExportedFile,
  getFile,
  getFilePreview,
  getFileUriSas,
  moveFile,
  refreshFile,
  renameFile,
  shareFile,
  shareFileRemove,
  shareFileUpdateAccess,
  shareList,
  updateQuoteSet,
} from './thunks/file';
import { uploadFiles } from './thunks/upload';
import { cancelAllUploads, cancelUploadById } from './thunks/cancel-upload';
import { moveFiles } from './thunks/move';
import { listShareableAccounts } from './thunks/shareable-accounts';
import { filesReducers } from './extra-reducers/files';
import { fileReducers } from './extra-reducers/file';
import { uploadReducers } from './extra-reducers/upload';
import {
  selectFilesReducer,
  importFilesReducer,
  clearImportedFilesReducer,
  resetShareListReducer,
  setFilePreviewReducer,
  clearPropertyFilesReducer,
  setRecentlyUploadedFileReducer,
  addMovingFilesReducer,
  clearMovingFilesReducer,
  updateMovingFileStatusReducer,
  setActiveFolderReducer,
} from './reducers';
import { shareableAccountsReducers } from './extra-reducers/shareable-accounts';

export {
  //files
  listFiles,
  listFilesNext,
  listShareBuckets,
  listSharedFiles,
  listSharedFilesNext,
  listPropertyFolderFiles,
  listPropertyFolderFilesNext,
  // files bin-page
  listTrashFiles,
  listTrashFilesNext,
  restoreTrashFile,
  //file
  createFolder,
  deleteFile,
  deleteQuoteSet,
  downloadFile,
  downloadFileData,
  duplicateFile,
  getExportedFile,
  getFile,
  getFilePreview,
  getFileUriSas,
  moveFile,
  refreshFile,
  renameFile,
  shareFile,
  shareFileRemove,
  shareFileUpdateAccess,
  shareList,
  updateQuoteSet,
  //upload
  uploadFiles,
  cancelAllUploads,
  cancelUploadById,
  //move
  moveFiles,
  //shareable accounts
  listShareableAccounts,
};

export const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    selectFiles: selectFilesReducer,
    setRecentlyUploadedFile: setRecentlyUploadedFileReducer,
    importFiles: importFilesReducer,
    clearImportedFiles: clearImportedFilesReducer,
    addMovingFiles: addMovingFilesReducer,
    clearMovingFiles: clearMovingFilesReducer,
    updateMovingFileStatus: updateMovingFileStatusReducer,
    setActiveFolder: setActiveFolderReducer,
    resetShareList: resetShareListReducer,
    setFilePreview: setFilePreviewReducer,
    clearPropertyFiles: clearPropertyFilesReducer,
  },
  extraReducers(builder) {
    filesReducers(builder);
    fileReducers(builder);
    uploadReducers(builder);
    shareableAccountsReducers(builder);
  },
});

export const {
  selectFile,
  selectFiles,
  setRecentlyUploadedFile,
  importFiles,
  clearImportedFiles,
  addMovingFiles,
  clearMovingFiles,
  updateMovingFileStatus,
  setActiveFolder,
  resetShareList,
  setFilePreview,
  clearPropertyFiles,
} = filesSlice.actions;

export default filesSlice.reducer;
